const propertytype_reducer = (state = "", action) => {
	switch(action.type) {

		case 'UPDATEPROPERTYTYPE':
			return action.payload;

		default:
			return state;
	}
}

export default propertytype_reducer;